export default "__VITE_ASSET__CES9_Djv__"